import { getCookie } from 'tiny-cookie'
import * as userService from '@/services/user'
import { fetchCompanyDetails } from '@/services/ma-franchise'
import segmentEvents from './segment-events'

function setupSegmentService() {
  return !(function() {
    const analytics = (window['analytics'] = window['analytics'] || [])
    if (!analytics.initialize)
      if (analytics.invoked)
        window.console &&
          console.error &&
          console.error('Segment snippet included twice.')
      else {
        analytics.invoked = !0
        analytics.methods = [
          'trackSubmit',
          'trackClick',
          'trackLink',
          'trackForm',
          'pageview',
          'identify',
          'reset',
          'group',
          'track',
          'ready',
          'alias',
          'debug',
          'page',
          'once',
          'off',
          'on',
          'addSourceMiddleware',
          'addIntegrationMiddleware',
          'setAnonymousId',
          'addDestinationMiddleware'
        ]
        analytics.factory = function(e) {
          return function() {
            const t = Array.prototype.slice.call(arguments)
            t.unshift(e)
            analytics.push(t)
            return analytics
          }
        }
        for (let e = 0; e < analytics.methods.length; e++) {
          const t = analytics.methods[e]
          analytics[t] = analytics.factory(t)
        }
        analytics.load = function(e, t) {
          const n = document.createElement('script')
          n.type = 'text/javascript'
          n.async = !0
          n.src = 'https://cdn.segment.com/analytics.js/v1/' + e + '/analytics.min.js'
          const a = document.getElementsByTagName('script')[0]
          a.parentNode.insertBefore(n, a)
          analytics._loadOptions = t
        }
        analytics.SNIPPET_VERSION = '4.1.0'
        analytics.load(process.env.VUE_APP_SEGMENT_TOKEN)
        analytics.page()
      }
  })()
}

export function identifyCurrentUser() {
  const TMSBetaUser = getCookie('TMSBetaUser')
  const isTMSBetaUser = TMSBetaUser && TMSBetaUser == true

  if (window['analytics']) {
    userService.fetchCurrentUser().then(userRes => {
      fetchCompanyDetails()
        .then(companyRes =>
          window['analytics'].identify(userRes.id, { ...userRes, ...companyRes, isTMSBetaUser })
        )
        .catch(() => window['analytics'].identify(userRes.id, userRes))
    })
  }
}

export function trackPage() {
  if (window['analytics']) window['analytics'].page()
}

export function trackEvent(event, properties) {
  if (!event) return
  if (window['analytics']) window['analytics'].track(event, properties)
}

export const SEGMENT_EVENTS = segmentEvents

export const loadSegmentService = () => {
  setupSegmentService()
  identifyCurrentUser()
}
